import { useMemo } from 'react';

import { useGetArticleGroupsQuery, useGetArticleTypesQuery, useGetAuthorQuery, useGetCommitteesQuery, useGetE1ArticleTitlesQuery } from 'services';

/**
 * Filtre şemasındaki `source` alanlarının seçenek ve ad kaynakları.
 *
 * Liste kaynakları (heyet, ansiklopedi grubu, madde türü) tüm seçenekleri bir kerede getirir. Arama kaynakları
 * (yazar, 1. edisyon maddesi) yalnız seçili id'lerin adını çözer; arama alanın kendi bileşenindedir.
 */

const EMPTY_TITLES = {};

const toOptions = (items) => items?.map(({ id, name }) => ({ value: String(id), label: name })) ?? [];

const LIST_QUERIES = {
  committees: useGetCommitteesQuery,
  articleGroups: useGetArticleGroupsQuery,
  articleTypes: useGetArticleTypesQuery,
};

/**
 * Liste kaynağının seçenekleri: `{ options: [{ value, label }], isLoading, isError }`. Değerler string id'dir.
 * `skip`: liste gerekmediğinde istek atılmaz.
 */
export const useFilterSourceOptions = (source, { skip = false } = {}) => {
  const { data, isLoading, isError } = LIST_QUERIES[source](undefined, { skip });
  const options = useMemo(() => toOptions(data), [data]);
  return { options, isLoading, isError };
};

/** Tek yazarın adı: `{ name, isLoading }`. Çözülemezse `name` `undefined`'dır. */
export const useAuthorName = (id) => {
  const { data, isLoading } = useGetAuthorQuery(id, { skip: !id });
  return { name: data?.user?.fullName, isLoading };
};

/** Seçili 1. edisyon maddelerinin başlıkları: `{ titles: { [id]: başlık }, isLoading }`. Çözülemeyen id `titles`'ta yer almaz. */
export const useE1ArticleTitles = (ids) => {
  const sortedIds = useMemo(() => [...ids].sort(), [ids]);
  const { data, isLoading } = useGetE1ArticleTitlesQuery(sortedIds, { skip: sortedIds.length === 0 });
  return { titles: data ?? EMPTY_TITLES, isLoading };
};
